import { getFormattedDate } from '../../utils/utils';
import { getStatus, getOrderType } from './utils';

export class OrderListModel {
  constructor(data) {
    const {
      status,
      quoteStatus,
      productSelectionFM,
      productType,
      orderId,
      createdAt,
      updatedAt,
      orderCreatedBy,
      orderAssignedTo,
      channel,
      legalBusinessNameFM,
      managedItServicesSummary,
      microsoftLicensingData,
      managedDetectionResponseData,
      discountValue,
      completedAt,
      appliedDiscountId,
      discount
    } = data || {};
    const discountStatus = appliedDiscountId ? discount.status : '';
    this.status = getStatus(status, discountStatus) || '-';
    
    // Make createdBy clickable by storing the original data
    this.createdBy = orderCreatedBy
      ? `${orderCreatedBy.firstName} ${orderCreatedBy.lastName}`
      : '-';
    this.createdByData = orderCreatedBy; // Store the full object for reassignment
    
    this.channel = channel ? channel.name : '-';
    this.typeOfInstallation = getOrderType(productSelectionFM, productType);
    this.orderId = orderId;
    this.updatedAt =
      (updatedAt && getFormattedDate(updatedAt, 'YYYY-MM-DD')) || '-';
    this.createdAt =
      (createdAt && getFormattedDate(createdAt, 'YYYY-MM-DD')) || '-';
    this.completedAt =
      (completedAt && getFormattedDate(completedAt, 'YYYY-MM-DD')) || '-';
    this.assignee = orderAssignedTo
      ? `${orderAssignedTo.firstName} ${orderAssignedTo.lastName}`
      : '-';
    this.legalBusinessNameFM = legalBusinessNameFM || '-';
    let totalMonthlyCharges = managedItServicesSummary
      ? parseFloat(managedItServicesSummary.totalMonthlyCharges) || 0
      : 0;

    if (microsoftLicensingData) {
      totalMonthlyCharges += parseFloat(microsoftLicensingData.adjustedTotalPrice) || 0;
    }
    if(Object.keys(managedDetectionResponseData || {}).length !== 0)
    {
        totalMonthlyCharges += parseFloat(managedDetectionResponseData.grandTotal || managedDetectionResponseData.totalPrice);
    }

    if (discountValue) {
      totalMonthlyCharges -= parseFloat(discountValue) || 0;
    }

    this.totalMonthlyCharges = totalMonthlyCharges ? (totalMonthlyCharges || 0).toFixed(2) : '-';
  }
}